import React, { useState } from 'react';
import GROUP from '../../images/3126647.png';
import FINISH from '../../images/2976392.png';
import MANAGER from '../../images/2202112.png';
import ALERT from '../../images/3119338.png';
import RESTART from '../../images/1350835.png';
import SIDE_MENU from '../../images/side-menu.png';
import { Link } from 'react-router-dom';

const NavigationBar = ({handleCurrentContainer, notes}) => {
  const [toggleNav, setToggleNav] = useState(false);

  return (
    <section className={`nav-res ${toggleNav? 'open' : ''}`}>
      <div  className='nav-res-btn' onClick={() => setToggleNav(!toggleNav)}>
        <img src={SIDE_MENU} alt='side-menu' />
      </div>
      <nav className='home-nav'>
        <div className='nav-btns'>
          <div>
            <img src={GROUP} alt='add employer' />
            <button onClick={() => handleCurrentContainer('addEmployer')}>ADD</button>
          </div>
          <div>
            <img src={FINISH} alt='finish to employer' />
            <button onClick={() => handleCurrentContainer('finish')}>FINISH</button>
          </div>
        </div>
        <div className='nav-m-l'>
          <div className='alert'  onClick={() => handleCurrentContainer('notes')}>
            <img src={ALERT} alt='manager' />
            {notes.length > 0 && <div className='alert-i'></div>}
          </div>
          <div  className='manager-btn' >
            <Link to='/admin'   onClick={() => handleCurrentContainer('notes')}>
              <img src={MANAGER} alt='manager' />
            </Link>
          </div>
          <div className='restart-btn'  onClick={() => handleCurrentContainer('restart')}>
            <img src={RESTART} alt='manager' />
          </div>
        </div>
      </nav>
    </section>
  )
}

export default NavigationBar;